module.exports = __webpack_public_path__ + "img/thumb_Atelier_10.01841b51.jpg";